// extracted by mini-css-extract-plugin
export default {"container":"Version_container__GLVtb","versionIcon":"Version_versionIcon__fVK7Z"};